module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmtitle"
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/004a_List"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/005_Foreword"
    }
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/006_World"
    }
  }, [_vm._v("Para’s World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/007_Places"
    }
  }, [_vm._v("Para’s Places")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/008_Humour"
    }
  }, [_vm._v("The Humour of ‘Para Handy’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/009_Print"
    }
  }, [_vm._v("Para in Print")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/010_Neil"
    }
  }, [_vm._v("Neil Munro")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/011_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Part01"
    }
  }, [_vm._v("THE "), _c('i', [_vm._v("VITAL SPARK")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013_Chapter01"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013_Chapter01"
    }
  }, [_vm._v("Para Handy, Master Mariner")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014_Chapter02"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014_Chapter02"
    }
  }, [_vm._v("The Prize Canary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015_Chapter03"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015_Chapter03"
    }
  }, [_vm._v("The Malingerer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016_Chapter04"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016_Chapter04"
    }
  }, [_vm._v("Wee Teeny")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/017_Chapter05"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/017_Chapter05"
    }
  }, [_vm._v("The Mate’s Wife")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/018_Chapter06"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/018_Chapter06"
    }
  }, [_vm._v("Para Handy – Poacher")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sea Cook")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lodgers on a House-boat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lost Man")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hurricane Jack")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy’s Apprentice")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queer Cargoes")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/025_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BIRTHPLACE OF PARA HANDY")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Search of a Wife")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy’s Piper")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sailors and the Sale")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CAREER OF CAPTAIN PETER MACFARLANE")])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Night Alarm")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Desperate Character")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tar’s Wedding")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Stroke of Luck")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PARA")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S OPINIONS")])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dougie’s Family")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Baker’s Little Widow")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Dry Days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Valentine that Missed Fire")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Disappointment of Erchie’s Niece")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy’s Wedding")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN HIGHLAND HARBOURS WITH PARA HANDY")])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/042_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/042_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Cook")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/043_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/043_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pension Farms")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy’s Pup")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treasure Trove")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/046_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/046_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luck")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salvage for the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy Has an Eye to Business")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/049_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/049_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Vegetarian Experiment")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/050_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/050_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Complete Gentleman")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/051_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/051_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ocean Tragedy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Return of the Tar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/053_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/053_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fortune-teller")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hair Lotion")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/055_Part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POLITICS, INTERNATIONAL AFFAIRS AND THE CREW OF THE "), _c('i', [_vm._v("VITAL SPARK")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/056_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/056_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy and the Navy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/057_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/057_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piracy in the Kyles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/058_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/058_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Among the Yachts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/059_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/059_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fog")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/060_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/060_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas on the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/061_Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/061_Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Maids of Bute")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/062_Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/062_Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herring – a Gossip")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/063_Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/063_Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Campbeltown by Sea")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/064_Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/064_Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Buy a Boat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/065_Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/065_Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stowaway")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/066_Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/066_Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confidence")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/067_Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/067_Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Goat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/068_Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/068_Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy’s Vote")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/069_Part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HURRICANE JACK OF THE "), _c('i', [_vm._v("VITAL SPARK")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/070_Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/070_Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hurricane Jack")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/071_Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/071_Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mystery Ship")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/072_Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/072_Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under Sealed Orders")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/073_Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/073_Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Search for Salvage")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/074_Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/074_Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wonderful Cheese")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/075_Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/075_Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phantom Horse and Cart")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/076_Chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/076_Chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hurricane Jack’s Luck-bird")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/077_Chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/077_Chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rowdy Visitor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/078_Chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/078_Chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fenian Goat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/079_Chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/079_Chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Land Girls")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/080_Chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/080_Chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leap Year on the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/081_Chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/081_Chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonnie Ann")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/082_Chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/082_Chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Leap-year Ball")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/083_Chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/083_Chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bottle King")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/084_Chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/084_Chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Mudges’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/085_Chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/085_Chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ocean Tragedy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/086_Chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/086_Chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freights of Fancy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/087_Chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/087_Chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer-time on the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/088_Chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/088_Chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs Uncontrolled")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/089_Chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/089_Chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commandeered")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/090_Chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/090_Chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunny Jim Rejected")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/091_Chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/091_Chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Jim Joined the Army")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/092_Chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/092_Chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fusilier")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/093_Chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/093_Chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MD")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/094_Chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/094_Chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Double Life")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/095_Chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/095_Chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wet Man of Muscadale")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/096_Part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PARA AND THE ‘SCRUPTURES’")])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "6%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/097_Chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/097_Chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initiation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/098_Chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/098_Chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of the World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/099_Chapter80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/099_Chapter80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Captured Cannon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/100_Chapter81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/100_Chapter81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ideal Job")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/101_Part09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNCOLLECTED STORIES 1905–24")])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "4%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "96%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/102_Chapter82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/102_Chapter82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy’s Shipwreck")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/103_Chapter83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/103_Chapter83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Vital Spark")]), _vm._v("’s Collision")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/104_Chapter84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/104_Chapter84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy at the Poll")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/105_Chapter85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/105_Chapter85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Vital Spark")]), _vm._v(" at the Celebration")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/106_Chapter86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/106_Chapter86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("War-time on the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/107_Chapter87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/107_Chapter87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Macfadyens")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/108_Chapter88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/108_Chapter88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Running the Blockade")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/109_Chapter89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/109_Chapter89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Canister King")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/110_Chapter90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/110_Chapter90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thrift on the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/111_Chapter91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/111_Chapter91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Difficulties in the Dry Area")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/112_Chapter92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/112_Chapter92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truth About the Push")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/113_Chapter93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/113_Chapter93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foraging for the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/114_Chapter94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/114_Chapter94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Gallant Allies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/115_Chapter95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/115_Chapter95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy’s Spectacles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/116_Chapter96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/116_Chapter96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy in the Egg Trade")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/117_Chapter97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/117_Chapter97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunny Jim Returns")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/118_Chapter98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/118_Chapter98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hurricane Jack’s Shootings")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/119_Chapter99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/119_Chapter99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wireless on the "), _c('i', [_vm._v("Vital Spark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tocr",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/120_Chapter100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/120_Chapter100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Para Handy on Yachting")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/121_Note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0